import React from 'react';
import { LoadingLottie } from '../../pages/2024/Teaser/lottie/LottieModal';

const FullScreenLoader = () => (
  <div className="fixed top-0 left-0 w-full h-full bg-almost-black bg-opacity-10 backdrop-blur-sm flex justify-center items-center z-[2000]">
    <LoadingLottie />
  </div>
);

export default FullScreenLoader;